import { Card, CardHeader, CardTitle, CardDescription, CardContent, Button } from '@exam-prep/ui';
import { t } from '@exam-prep/i18n';
import { useLoad } from '../../../lib/useLoad';
import { untilIst } from '../../../lib/format';
import { api } from '../../../lib/api';
import type { Plans as PlansData } from '../model/plans-response';
import { closeApp } from '../../../lib/tma';
import { PlanGroups } from '../ui/Plans';

/**
 * Plans and prices in Telegram Stars (ADR 0028). Prices come from the server; an offer shows
 * its list price struck through; no offer ever shows an end date, a cap or a spots count. Buying
 * happens in the chat (/upgrade), where the invoice is created.
 */
export function PlansCard() {
  const { data } = useLoad(() => api<PlansData>('GET', '/app/plans'), []);
  if (!data?.plans.length) return null;
  const offers = [
    ...new Map(
      data.plans.flatMap((p) =>
        p.offer ? [[`${p.offer.label}|${p.offer.endsAt}`, p.offer]] : [],
      ) as [string, { label: string; endsAt: string | null }][],
    ).values(),
  ];
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('miniapp.plans.title')}</CardTitle>
        <CardDescription>
          {data.pro
            ? t('miniapp.plans.have_pro', { date: untilIst(data.pro.until) })
            : t('miniapp.plans.subtitle')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {offers.map((o) => (
          <p
            key={`${o.label}|${o.endsAt}`}
            className="offer-note rounded-xl border px-3 py-2 text-xs"
          >
            <span className="font-semibold">{o.label}:</span>{' '}
            {/* Never an end date, a cap or a spots count on an offer (product rule). */}
            {t('miniapp.plans.offer_regular')}
          </p>
        ))}
        <PlanGroups plans={data.plans} doubtCredits={data.doubtCredits} />
        <p className="text-xs text-muted-foreground">{t('miniapp.plans.how_to_buy')}</p>
        <Button variant="outline" className="w-full" onClick={closeApp}>
          {t('miniapp.plans.buy')}
        </Button>
      </CardContent>
    </Card>
  );
}
